import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { LayoutDashboard, Users, CalendarCheck, Wallet, ReceiptText, TreePine, Medal, ShieldCheck } from "lucide-react";
import { Sidebar, MobileNav } from "@/components/layout/NavParts";

const adminNavItem = { to: "/leaders", label: "Leaders", icon: ShieldCheck, testid: "nav-leaders" };

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/members", label: "Members", icon: Users, testid: "nav-members" },
  { to: "/attendance", label: "Attendance", icon: CalendarCheck, testid: "nav-attendance" },
  { to: "/fees", label: "Fees", icon: Wallet, testid: "nav-fees" },
  { to: "/ledger", label: "Payments Ledger", icon: ReceiptText, testid: "nav-ledger" },
  { to: "/camps", label: "Camps", icon: TreePine, testid: "nav-camps" },
  { to: "/skills", label: "Skills", icon: Medal, testid: "nav-skills" },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = user?.role === "admin";
  const [pending, setPending] = useState(0);
  const items = isAdmin ? [...navItems, adminNavItem] : navItems;

  useEffect(() => {
    if (!isAdmin) return;
    api.get("/admin/users/pending-count").then((r) => setPending(r.data.count)).catch(() => setPending(0));
  }, [isAdmin]);

  const handleLogout = async () => { await logout(); nav("/login"); };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-background">
      <Sidebar items={items} pending={pending} user={user} onLogout={handleLogout} />
      <MobileNav items={items} onLogout={handleLogout} />
      <main className="flex-1 md:ml-64 pb-20 md:pb-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
